/**
 * "toast.js"
 * Created by Michael Cheng on 05/31/2015 22:34
 *           http://michaelcheng.us/
 *           michael@michaelcheng.us
 *           --All Rights Reserved--
 *
 * https://github.com/mlcheng/js-toast
 */

// 'use strict';

const iqwerty = {};

iqwerty.toast = (function toast() {
  /**
   * The Toast animation speed; how long the Toast takes to move to and from the screen
   * @type {Number}
   */
  const TOAST_ANIMATION_SPEED = 400;

  const Transitions = {
    SHOW: {
      '-webkit-transition': `opacity ${TOAST_ANIMATION_SPEED}ms, -webkit-transform ${TOAST_ANIMATION_SPEED}ms`,
      transition: `opacity ${TOAST_ANIMATION_SPEED}ms, transform ${TOAST_ANIMATION_SPEED}ms`,
      opacity: '1',
      '-webkit-transform': 'translateY(-100%) translateZ(0)',
      transform: 'translateY(-100%) translateZ(0)',
    },

    HIDE: {
      opacity: '0',
      '-webkit-transform': 'translateY(150%) translateZ(0)',
      transform: 'translateY(150%) translateZ(0)',
    },
  };

  /**
   * The toastStage. This is the HTML element in which the toast resides
   * Getter and setter methods are available privately
   * @type {Element}
   */
  // eslint-disable-next-line no-underscore-dangle
  let _toastStage = null;

  function getToastStage() {
    return _toastStage;
  }

  function setToastStage(toastStage) {
    _toastStage = toastStage;
  }

  /**
   * The main Toast object
   * @param {String} text    The text to put inside the Toast
   * @param {Object} options Optional; the Toast options.
   *                         See Toast.prototype.DEFAULT_SETTINGS for more information
   * @param {Object} transitions Optional; the Transitions object.
   *                         This should not be used unless you know what you're doing
   */
  function Toast(text, options, transitions) {
    if (getToastStage() !== null) {
      // If there is already a Toast being shown, put this Toast in the queue to show later
      Toast.prototype.toastQueue.push({
        text,
        options,
        transitions,
      });
    } else {
      Toast.prototype.Transitions = transitions || Transitions;
      // eslint-disable-next-line no-underscore-dangle
      let _options = options || {};
      _options = Toast.prototype.mergeOptions(Toast.prototype.DEFAULT_SETTINGS, _options);

      Toast.prototype.show(text, _options);

      _options = null;
    }
  }

  // define some Toast constants

  /**
   * The default Toast settings
   * @type {Object}
   */
  Toast.prototype.DEFAULT_SETTINGS = {
    style: {
      main: {
        // background: 'rgba(0, 0, 0, .85)',
        // 'box-shadow': '0 0 10px rgba(0, 0, 0, .8)',
        // 'border-radius': '3px',

        'z-index': '99999',

        color: 'rgba(255, 255, 255, .9)',

        padding: '10px 15px',
        // 'max-width': '60%',
        width: '100%',
        'word-break': 'keep-all',
        margin: '0 auto',
        'text-align': 'center',

        position: 'fixed',
        left: '0',
        right: '0',
        bottom: '0',

        '-webkit-transform': 'translateY(150%) translateZ(0)',
        transform: 'translateY(150%) translateZ(0)',
        '-webkit-filter': 'blur(0)',
        opacity: '0',
      },
    },

    settings: { duration: 4000 },
  };

  Toast.prototype.Transitions = {};


  /**
   * The queue of Toasts waiting to be shown
   * @type {Array}
   */
  Toast.prototype.toastQueue = [];


  /**
   * The Timeout object for animations.
   * This should be shared among the Toasts, because timeouts may be cancelled
   * e.g. on explicit call of hide()
   * @type {Object}
   */
  Toast.prototype.timeout = null;


  /**
   * Merge the DEFAULT_SETTINGS with the user defined options if specified
   * @param  {Object} options The user defined options
   */
  Toast.prototype.mergeOptions = function mergeOptions(initialOptions, customOptions) {
    const merged = customOptions;

    Object.keys(initialOptions).forEach((prop) => {
      // eslint-disable-next-line no-prototype-builtins
      if (merged.hasOwnProperty(prop)) {
        if (initialOptions[prop] !== null && initialOptions[prop].constructor === Object) {
          merged[prop] = Toast.prototype.mergeOptions(initialOptions[prop], merged[prop]);
        }
      } else {
        merged[prop] = initialOptions[prop];
      }
    });

    return merged;
  };


  /**
   * Generate the Toast with the specified text.
   * @param  {String|Object} text    The text to show inside the Toast,
   *                                 can be an HTML element or plain text
   * @param  {Object} style   The style to set for the Toast
   */
  Toast.prototype.generate = function generate(text, style, className) {
    let toastStage = document.createElement('div');

    if (typeof className === 'string') {
      toastStage.className = className;
    }

    /**
     * If the text is a String, create a textNode for appending
     */
    if (typeof text === 'string') {
      // eslint-disable-next-line no-param-reassign
      text = document.createTextNode(text);
    }

    toastStage.appendChild(text);

    const clickHandler = () => {
      const item = getToastStage();
      if (item) {
        item.removeEventListener('click', clickHandler);
      }
      this.hide();
    };

    toastStage.addEventListener('click', clickHandler, false);

    setToastStage(toastStage);
    toastStage = null;

    Toast.prototype.stylize(getToastStage(), style);
  };

  /**
   * Stylize the Toast.
   * @param  {Element} element The HTML element to stylize
   * @param  {Object}  styles  An object containing the style to apply
   * @return                   Returns nothing
   */
  Toast.prototype.stylize = function stylize(element, styles) {
    Object.keys(styles).forEach((style) => {
      // eslint-disable-next-line no-param-reassign
      element.style[style] = styles[style];
    });
  };


  /**
   * Show the Toast
   * @param  {String} text    The text to show inside the Toast
   * @param  {Object} options The object containing the options for the Toast
   */
  Toast.prototype.show = function show(text, options) {
    this.generate(text, options.style.main, options.className);

    let toastStage = getToastStage();
    document.body.insertBefore(toastStage, document.body.firstChild);

    // This is a hack to get animations started.
    // Apparently without explicitly redrawing, it'll just attach the class
    // and no animations would be done
    // eslint-disable-next-line no-unused-expressions
    toastStage.offsetHeight;

    Toast.prototype.stylize(toastStage, Toast.prototype.Transitions.SHOW);

    toastStage = null;

    // Hide the Toast after the specified time
    clearTimeout(Toast.prototype.timeout);
    Toast.prototype.timeout = setTimeout(Toast.prototype.hide, options.settings.duration);
  };


  /**
   * Hide the Toast that's currently shown
   */
  Toast.prototype.hide = function hide() {
    let toastStage = getToastStage();
    Toast.prototype.stylize(toastStage, Toast.prototype.Transitions.HIDE);

    // Destroy the Toast element after animations end
    clearTimeout(Toast.prototype.timeout);
    toastStage.addEventListener('transitionend', Toast.prototype.animationListener);
    toastStage = null;
  };

  Toast.prototype.animationListener = function animationListener() {
    getToastStage().removeEventListener('transitionend', Toast.prototype.animationListener);
    Toast.prototype.destroy.call(this);
  };


  /**
   * Clean up after the Toast slides away. Namely, removing the Toast from the DOM.
   * After the Toast is cleaned up, display the next Toast in the queue if any exists
   */
  Toast.prototype.destroy = function destroy() {
    let toastStage = getToastStage();
    document.body.removeChild(toastStage);

    toastStage = null;
    setToastStage(null);


    if (Toast.prototype.toastQueue.length > 0) {
      // Show the rest of the Toasts in the queue if they exist

      // eslint-disable-next-line no-shadow
      let toast = Toast.prototype.toastQueue.shift();
      Toast(toast.text, toast.options, toast.transitions);

      // clean up
      toast = null;
    }
  };

  return { Toast };
}());

export default iqwerty.toast;
